import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Settings } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/general')({
    staticData: {
        breadcrumb: {
            title: 'General settings',
            inactive: true,
        },
        modules: ['compliance'],
        permissions: ['settings:update'],
        ui: {
            icon: Settings,
            title: 'General settings',
            useTitleForChildren: true,
            menuDescription: 'Shared settings used across complaints and incidents',
        },
    },
    component: Outlet,
});
